import * as _ from "lodash";
import deliveryMethodService, { DeliveryMethodsByContractType } from "features/offers/deliveryMethodService";
import { useEffect, useState } from "react";
import IsLoaded from "common/isLoaded";

const getCached = _.memoize(() => deliveryMethodService.listAll());

let data: DeliveryMethodsByContractType = null;
const defaultVal = {};

export default function useAllowedDeliveryMethods(): DeliveryMethodsByContractType {

    const [isLoading, setIsLoading] = useState(false);

    if (data == null && !isLoading) {
        setIsLoading(true);
        getCached().then(m => {
            data = m;
            setIsLoading(false);
        });
        return defaultVal;
    }

    return data;
}

export function useAllowedDeliveryMethodsLoader(): IsLoaded<DeliveryMethodsByContractType> {

    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        getCached().then(m => {
            data = m;
            setIsLoaded(true);
        });
    }, [])

    return { isLoaded, data: isLoaded ? data : defaultVal };
}